import { API_BASE_URL } from '../../config/api';
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import logo from '../../Assets/images/logo.png';
import paynet from '../../Assets/images/pay/logo-paynet.svg';
import Paynet from '../component/Paynet';
import { toast } from 'react-toastify';
import axios from 'axios';

Modal.setAppElement('#root');

const PopupDonation = () => {
    const { t } = useTranslation();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [check, setCheck] = useState(false);
    const [price, setPrice] = useState(100);
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [paymentData, setPaymentData] = useState(null);

    // Сброс состояния загрузки при возврате на страницу (Back button / BFCache / Tab focus)
    useEffect(() => {
        const handleReset = () => {
            setLoading(false);
            setPaymentData(null);
        };

        window.addEventListener('pageshow', handleReset);
        window.addEventListener('focus', handleReset);
        window.addEventListener('popstate', handleReset);

        return () => {
            window.removeEventListener('pageshow', handleReset);
            window.removeEventListener('focus', handleReset);
            window.removeEventListener('popstate', handleReset);
        };
    }, []);

    const openModal = () => {
        setModalIsOpen(true);
    };

    const handleCloseModal = () => {
        setModalIsOpen(false);
        setCheck(false);
        setPrice(100);
        setEmail('');
    };

    const handleCheckChange = () => {
        setCheck(prev => !prev);
    };

    const handlePriceChange = (event) => {
        setPrice(event.target.value);
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const showNotification = (message, type) => {
        toast(message, { type });
    };

    const handleSendClick = async (e) => {
        e.preventDefault();

        if (!check) {
            showNotification(t('donation.popup.title') || 'Pentru a plăti, trebuie să fiți de acord cu termenii de confidențialitate', 'warning');
            return;
        }

        if (!price || Number(price) <= 0) {
            showNotification(t('donation.popup.enterAmount') || 'Introduceți o sumă validă', 'warning');
            return;
        }

        setLoading(true);
        const formDataToSend = new FormData();
        formDataToSend.append('title', t('donation.title'));
        formDataToSend.append('count', price);
        if (email && email.trim()) {
            formDataToSend.append('email', email.trim());
        }

        const timer = setTimeout(() => {
            setLoading(false);
        }, 6000);

        try {
            const response = await axios.post(`${API_BASE_URL}/pay/payment/`, formDataToSend, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            setPaymentData(response.data);
        } catch (error) {
            clearTimeout(timer);
            setLoading(false);
            showNotification(t('cart.error') || 'Что-то пошло не так при создании платежа', 'error');
        }
    };

    return (
        <div>
            {paymentData && <Paynet paymentData={paymentData} />}
            <div onClick={openModal} className="main-content__product product_pay product-box paynet select_none">
                <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                    <div className="main-content__product__image" itemProp="image">
                        <img src={paynet} alt="Paynet" />
                    </div>
                    <p className="main-content__product__name" itemProp="name">{t('donation.paynet.name')}</p>
                    <p className="main-content__product__description">{t('donation.paynet.description')}</p>
                </div>
                <div className="main-content__product__to-cart-box" itemProp="offers">
                    <span data-set="1" className="main-content__product__cart-button put-set-to-cart" id="add-to-cart">
                        <button className="btn-bay">{t('donation.donate')}</button>
                    </span>
                </div>
            </div>
            <Modal
                isOpen={modalIsOpen}
                onRequestClose={handleCloseModal}
                contentLabel={t('donation.title') || 'Donație'}
                shouldCloseOnOverlayClick={false}
                className="stype_upload_popup popup_height_auto"
            >
                <div className="contain_modal">
                    <div className="modal-header">
                        <h3 className="modal-title">{t('donation.popup.title')}</h3>
                        <button className="close" onClick={handleCloseModal} aria-label="Close">×</button>
                    </div>
                    <div className="modal-body">
                        <div className="modal__politic">
                            <img src={logo} alt="Frigider Comunitar" />
                            <h4 className="modal_politic_title">{t('donation.title')}</h4>
                            <p className="modal_politic_description">{t('donation.description')}</p>
                        </div>
                        <form className="form_styles" onSubmit={handleSendClick}>
                            <label htmlFor="price">{t('donation.popup.price') || 'Suma (MDL):'}</label>
                            <input
                                type="number"
                                min="1"
                                id="price"
                                value={price}
                                onChange={handlePriceChange}
                                required
                                placeholder="100"
                            />

                            <label htmlFor="email">{t('donation.popup.email') || 'Email:'}</label>
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={handleEmailChange}
                                placeholder="example@mail.com"
                            />

                            <div className={`main_cart__offert__action select_none ${check ? 'active' : ''}`}>
                                <input
                                    id="accept-offer-conf"
                                    type="checkbox"
                                    className="main-cart__offert__action__checkbox set-cart-offert"
                                    name="accept-offer-conf"
                                    onChange={handleCheckChange}
                                    checked={check}
                                />
                                <label htmlFor="accept-offer-conf" className="main_cart__offert__action__label">
                                    {t('donation.popup.agreeWith')}{' '}
                                    <Link className="main-registration__accepts__link" to="/politic">
                                        {t('donation.popup.privacyPolicy')}
                                    </Link>
                                </label>
                            </div>

                            <div className="modal_submit_wrap select_none">
                                <button
                                    type="submit"
                                    className={`but-grey ${check ? 'active' : ''}`}
                                    disabled={!check || loading}
                                >
                                    {loading ? '...' : (t('donation.popup.send') || 'Trimite')}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default PopupDonation;
